import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import cloneDeep from 'lodash-es/cloneDeep';
import isFunction from 'lodash-es/isFunction';

interface ClickAction {
    text: string;
    tooltip?: string;
    disabled?: boolean;
    visible?: boolean;
    onClick?: (data: any, params: ICellRendererParams) => void;
    computeDisabledState?: (data: any) => boolean;
    computeVisibleState?: (data: any) => boolean;
    computeTooltip?: (data: any) => string;
}

interface ClickActionRendererParams {
    action: ClickAction;
    alignment?: 'left' | 'center' | 'right';
}

@Component({
    selector: 'app-click-action-renderer',
    imports: [TranslateModule],
    templateUrl: './click-action-renderer.component.html',
    styleUrl: './click-action-renderer.component.scss',
})
export class ClickActionRendererComponent {
    public action!: ClickAction;
    public computedFields: { [key: string]: any } = {};
    protected alignment?: 'left' | 'center' | 'right';
    private params!: ICellRendererParams;

    protected computableFieldMap: [keyof ClickAction, keyof ClickAction][] = [
        ['disabled', 'computeDisabledState'],
        ['tooltip', 'computeTooltip'],
        ['visible', 'computeVisibleState'],
    ];

    public agInit(params: ICellRendererParams): void {
        this.params = params;
        this.updateComponentState(params);
    }

    public refresh(params: ICellRendererParams): boolean {
        this.params = params;
        this.updateComponentState(params);
        return true;
    }

    public handleClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        if (this.action.onClick && isFunction(this.action.onClick)) {
            this.action.onClick(this.params.data, this.params);
        }
    }

    private updateComponentState(params: ICellRendererParams): void {
        const cellRendererParams = (params.colDef?.cellRendererParams || {}) as ClickActionRendererParams;

        this.action = cloneDeep(cellRendererParams.action);
        this.computedFields = {};
        this.alignment = cellRendererParams.alignment;

        this.action.text = params.value;

        this.computableFieldMap.forEach(([field, computeFnKey]) => {
            const computeFn = this.action[computeFnKey] as ((data: any) => any) | undefined;
            if (isFunction(computeFn)) {
                this.computedFields[field] = computeFn(params.data);
            }
        });
    }
}
